import * as d3 from 'd3'
import { CUSTOM_LABEL_ID, getUtcDateAndTime } from '../../../../library/utils'
import { CPITimePeriod, Label } from 'models'
import theme from 'theme'
import { resolveThemeColor } from 'theme/config'
import { getActiveThemeMode } from 'theme/themeMode'
// import { chartHeightStart } from '../chart-utils'

interface Props {
  countIndicatorButton: d3.Selection<SVGGElement, unknown, null, undefined>
  pinnedLabels?: Label[]
  selectedTimePeriod: CPITimePeriod
  filledDates: string[]
  indicatorValue: number
  stripeWidth: number
  index: number
  height: number
  date: string
}

export const appendButtonCountIndicator = ({
  countIndicatorButton,
  pinnedLabels,
  selectedTimePeriod,
  filledDates,
  indicatorValue,
  stripeWidth,
  index,
  height,
  date
}: Props) => {
  const hasPinned = pinnedLabels?.find((n) => {
    const isCustomLabel = n.action === CUSTOM_LABEL_ID
    const convertedDate = getUtcDateAndTime(isCustomLabel && n.data.date ? n.data.date : n.created_at)
    let dateHasPinned = convertedDate.isoFormattedDate.slice(0, 10) === date
    if (selectedTimePeriod !== CPITimePeriod.Week) {
      dateHasPinned = filledDates.includes(convertedDate.isoFormattedDate.slice(0, 10))
    }

    return dateHasPinned
  })

  if (indicatorValue <= 0) return

  const mode = getActiveThemeMode()
  const pinkStroke = resolveThemeColor('cta', mode)
  const whiteStroke = resolveThemeColor('count-indicator-num', mode)

  /* Count Indicator Button */
  countIndicatorButton
    .append('circle')
    .attr('cx', stripeWidth * index + stripeWidth / 2)
    .attr('cy', height)
    .attr('r', 12)
    .attr('fill', resolveThemeColor('card-fill-primary', mode))
    .attr('stroke', hasPinned ? pinkStroke : resolveThemeColor('button-circle-border', mode))
    .attr('stroke-width', 2.33)
    .attr('filter', 'drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.30)) drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.15))')
    .attr('display', 'block')
  countIndicatorButton
    .append('text')
    .attr('x', stripeWidth * index + stripeWidth / 2)
    .attr('y', height + 5)
    .attr('text-anchor', 'middle')
    .attr('font-size', theme.typography.fontSize.large)
    .attr('font-family', theme.typography.fontFamily.primary)
    .attr('font-weight', `${theme.typography.fontWeight.bold}`)
    .attr('line-height', '20px')
    .attr('letter-spacing', '0.1px')
    .attr('fill', hasPinned ? pinkStroke : whiteStroke)
    .attr('display', 'block')
    .text(indicatorValue)

  /* Count Indicator Tooltip */
  countIndicatorButton
    .append('rect')
    .attr('class', 'count-rect-tooltip-wrapper')
    .attr('x', stripeWidth * index + stripeWidth / 2 - 65)
    .attr('y', height + 17)
    .attr('width', 159)
    .attr('height', 40)
    .attr('fill', resolveThemeColor('tooltip-bg', mode))
    .attr('box-shadow', '0px 4px 8px 0px #1E1A1D')
    .attr('border-radius', '12px')
    .attr('rx', 8)
    .style('display', 'none')
    .style('transform', 'translateX(-20px)')
  countIndicatorButton
    .append('text')
    .attr('class', 'count-rect-tooltip-text')
    .attr('x', stripeWidth * index + stripeWidth / 2 - 21)
    .attr('y', height + 42)
    .style('fill', resolveThemeColor('text-primary', mode))
    .style('font-size', theme.typography.fontSize.large)
    .style('font-family', theme.typography.fontFamily.primary)
    .style('font-weight', `${theme.typography.fontWeight.bold}`)
    .style('line-height', '20px')
    .style('letter-spacing', '0.1px')
    .style('display', 'none')
    .style('transform', 'translateX(25px)')
    .text(`${indicatorValue} System Event${indicatorValue === 1 ? '' : 's'}`)
}
